// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--edc43","grid":"grid--edd58","card":"card--c8b68"};